import styled from "styled-components";

type ItemColumType = {
    color: string;
    width: number;
}

type ColumType = {
    width: number;
}

export const TextMainEllipsis = styled.span`
    max-width: 170px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const ContainerHeaderColumn = styled.div`
    display: flex;
    flex-direction: row;
    height: 35px;
    padding: 0 16px;
`;
export const ContainerHeaderText = styled.div<ItemColumType>`
    display: flex;
    align-items: center;
    max-width: ${(props) => `${props.width}px`};
    width: ${(props) => `${props.width}px`};
    color: ${props => props.color};
    font-size: 14px;
`;

export const ContainerColumn = styled.div`
    display: flex;
    flex-direction: row;
    height: 35px;
    align-items: center;
`;

export const ContentColumn = styled.div<ColumType>`
    display: flex;
    flex-direction: row;
    max-width: ${(props) => `${props.width}px`};
    width: ${(props) => `${props.width}px`};
`;